export interface SharingWizardUiState {
  /** Index of the currently active step in the create/edit sharing profile stepper. */
  currentStep: number;
  /** Whether the stepper is editing an existing sharing profile (true) or creating a new one (false). */
  isEditMode: boolean;
  /** Whether the current draft has unsaved changes since it was opened or last saved. */
  hasUnsavedChanges: boolean;
}

export const initialWizardUiState: SharingWizardUiState = {
  currentStep: 0,
  isEditMode: false,
  hasUnsavedChanges: false,
};
